module.exports = __webpack_public_path__ + "img/9e1b7b3.png";